import { readable, type Readable } from 'svelte/store';

export function innerWidthStore({
    browser,
    defaultValue,
}: {
    browser: boolean;
    defaultValue: number;
}): Readable<number> {
    if (!browser) {
        return readable(defaultValue);
    }

    return readable(window.innerWidth, (set) => {
        window.addEventListener('resize', () => {
            set(window.innerWidth);
        });
    });
}
